export default "__VITE_ASSET__a4e95872__"